    /**
     * Property Card Slider
     * Handles carousel functionality using Slick Slider (CDN Version)
     */

    jQuery(document).ready(function ($) {

        function initPropertySlider() {
            // Iterate over each slider wrapper to scope controls
            $('.properties-slider-wrapper').each(function () {
                const $wrapper = $(this);
                const $slider = $wrapper.find('.properties-slider');
                // Select custom dots (generated by PHP)
                const $dots = $wrapper.find('.slider-dots .dot');

                if (!$slider.length) return;

                // Check for Slick
                if (typeof $slider.slick !== 'function') {
                    console.warn('Property Slider: Slick not loaded. Check if Slick JS is enqueued after jQuery.');
                    return;
                }

                // Destroy if already initialized to reset
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('unslick');
                }

                // Remove previous event listeners to prevent duplicates
                $dots.off('click');
                $slider.off('beforeChange');

                // Initialize Slick with scoped controls but NO auto-dots
                $slider.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    arrows: true,
                    prevArrow: $wrapper.find('.slider-arrow.prev'),
                    nextArrow: $wrapper.find('.slider-arrow.next'),
                    dots: false, // User wants to control dots manually
                    responsive: [
                        {
                            breakpoint: 1280, // <= 1280px
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 1024, // <= 1024px
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 767, // <= 767px
                            settings: {
                                slidesToShow: 1,
                                arrows: false
                            }
                        }
                    ]
                });

                // Handle Custom Dot Click
                $dots.on('click', function () {
                    const index = $(this).data('slide');
                    if (typeof index !== 'undefined') {
                        $slider.slick('slickGoTo', index);
                    }
                });

                // Update Active Dot on Slide Change
                $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    $dots.removeClass('active');
                    // The 'data-slide' matches the index 0, 1, 2...
                    $dots.filter(`[data-slide="${nextSlide}"]`).addClass('active');
                });
            });
        }

        initPropertySlider();
    });
